<template>
	<section class="finance-qa" v-if="questions.length">
		<div class="section-title">常见问题</div>
		<div
			v-for="item in questions"
			:key="item.id"
			class="qa-item"
			@click="openQuestion(item)"
			v-open-launch-app
		>
			<img class="qa-icon" :src="qaIcon" />
			<div class="qa-text">{{ item.question }}</div>
			<nio-icon name="icon_arrows_right_2xs" :size="16" />
		</div>
	</section>
</template>

<script>
import util from '@/util/util'
import hybrid from '@/util/nativeHybrid'
import { filterConditionConfigModel } from '@/model'

const FINANCE_QUESTION_KEY = 'commodity.toc.finance-question'

export default {
	name: 'FinanceQA',
	data() {
		return {
			qaIcon: 'https://cdn-fx.nio.com/fx/second-hand-app-pkg/__cdn__/icon_question_nio.png',
			questions: []
		}
	},
	created() {
		this.fetchQuestions()
	},
	methods: {
		async fetchQuestions() {
			try {
				const res = await filterConditionConfigModel.get({ keys: FINANCE_QUESTION_KEY })
				this.questions = res.data.data[FINANCE_QUESTION_KEY]
			} catch (e) {
				this.questions = []
			}
		},
		openQuestion(item) {
			hybrid.openURL(
				`nio://conversation?id=${
					util.getBaseEnvInfo().secondHandChatPersonId
				}&type=private&msg=${encodeURIComponent(item.question)}`
			)
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.finance-qa {
	margin-top: 40px;
	padding: 0 20px 35px;
}

.section-title {
	margin-bottom: 15px;
	@include subtitle_2(1.5, 500, false);
}

.qa-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	@include body_2(1.5, 400, false);

	& + & {
		margin-top: 15px;
	}

	.qa-icon {
		width: 16px;
		height: 16px;
		margin-right: 5px;
		font-size: 0;
	}

	.qa-text {
		flex: 1;
		display: inline-block;
		width: calc(100vw - 84px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.nio-icon {
		flex: 0 0 auto;
		margin-left: 12px;
		color: $text_tertiary;
	}
}
</style>
